import { AUTH_SUCCESS, AUTH_FAILURE } from '../actions/types';

const initialState = false;

export default function authReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case AUTH_SUCCESS:
      return payload;
    case AUTH_FAILURE:
      return false;

    default:
      return state;
  }
}
